


















































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import Ajax from '@/lib/ajax'
import AppConsts from '../../../lib/appconst'
// import AreaCascader from "@/components/area/index.vue";
import { pca, pcaa } from 'area-data' // 城市数据
import 'vue-area-linkage/dist/index.css' // 样式
import gadMapArea from '@/components/map/map.vue'
import ShopApi from '@/api/shopInfo/index'

class CreateOrUpdateStoreDto {
  // storeType: number;
  // areaSize: string;
  longitude: number
  latitude: number
  diyCode: string
  displayName: string
  province: string
  city: string
  district: string
  address: string
  principal: string
  phoneNumber: string
  // parentId: number;
  id?: number
}
@Component({
  components: {
    // AreaCascader
    gadMapArea,
  },
})
export default class OrganizationFramework extends AbpBase {
  remote: string = AppConsts.remoteServiceBaseUrl
  uploadUrl: string = `${AppConsts.remoteServiceBaseUrl}File/UploadMedia`
  select: any = []
  formValidate: CreateOrUpdateStoreDto = new CreateOrUpdateStoreDto()
  ruleValidate: any = {
    diyCode: [{ required: true, message: '代码不能为空', trigger: 'blur' }],
    displayName: [
      { required: true, message: '店铺名称不能为空', trigger: 'blur' },
    ],
    // storeType: [
    //   {
    //     required: true,
    //     message: "性质名称不能为空",
    //     trigger: "blur",
    //     type: "number"
    //   }
    // ],
    select: [
      {
        required: true,
        validator: (rule, value, callback) => {
          // console.log(value);
          if (value && value.length !== 3) {
            callback(new Error('请选择省市区'))
          } else {
            callback()
          }
        },
        trigger: 'change',
      },
    ],
    address: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
    principal: [{ required: true, message: '负责人不能为空', trigger: 'blur' }],
    phoneNumber: [
      {
        required: true,
        validator: (rule, value, callback) => {
          if (!value) {
            callback(new Error('手机号不能为空'))
          } else if (!/^1[34578]\d{9}$/.test(value)) {
            callback(new Error('手机号格式不正确'))
          } else {
            callback()
          }
        },
        trigger: 'blur',
      },
    ],
  }
  // storeTypeList: any[] = [
  //   {
  //     value: 0,
  //     label: "加盟"
  //   },
  //   {
  //     value: 1,
  //     label: "代理"
  //   },
  //   {
  //     value: 2,
  //     label: "联营"
  //   },
  //   {
  //     value: 3,
  //     label: "直营"
  //   }
  // ];
  visible: boolean = false
  uploadList: any[] = []
  hackReset: boolean = true
  pca: any = pca
  pcaa: any = pcaa
  showMap: boolean = false

  @Watch('$route')
  routeChange(to: any, old: any) {
    if (to.name !== old.name) {
      this.formValidate = new CreateOrUpdateStoreDto()
      this.getStoreForEdit()
    }
  }

  created() {
    this.getStoreForEdit()
  }
  lnglatHandler(e) {
    this.$set(this.formValidate, 'longitude', e[0])
    this.$set(this.formValidate, 'latitude', e[1])
    // console.log(this.formValidate);
  }
  onCloseMap(e) {
    console.log(e)
    this.showMap = e
  }
  selectArea(value) {
    console.log(value)
    if (value[0].code === undefined) {
      value = value.map((currentValue, index, arr) => {
        return {
          code: Object.keys(currentValue)[0],
          name: Object.values(currentValue)[0],
        }
      })
      this.formValidate.province = JSON.stringify(value[0])
      this.formValidate.city = JSON.stringify(value[1])
      this.formValidate.district = JSON.stringify(value[2])
    } else {
      this.formValidate.province = JSON.stringify(value[0])
      this.formValidate.city = JSON.stringify(value[1])
      this.formValidate.district = JSON.stringify(value[2])
    }
  }
  getStoreForEdit() {
    if (this.$route.params.id) {
      Ajax.get(
        `api/services/app/Store/GetStoreForEdit?Id=${this.$route.params.id}`
      ).then((res) => {
        if (res.data.success) {
          let tempArr = []
          tempArr[0] = JSON.parse(res.data.result.province).code
          tempArr[1] = JSON.parse(res.data.result.city).code
          tempArr[2] = JSON.parse(res.data.result.district).code
          this.select = tempArr
          this.formValidate = res.data.result
        }
      })
    }
  }
  handleSubmit(name) {
    ;(this.$refs[name] as any).validate((valid) => {
      if (valid) {
        if (this.select && this.select.length !== 3) {
          this.$Message.warning('请选择省市区')
        } else {
          const obj = {
            displayName: this.formValidate.displayName,
            code: this.formValidate.diyCode,
            city: JSON.parse(this.formValidate.city).name,
            province: JSON.parse(this.formValidate.province).name,
            district: JSON.parse(this.formValidate.district).name,
            detailAddress: this.formValidate.address,
            longitude: this.formValidate.longitude,
            latitude: this.formValidate.latitude,
            manager: this.formValidate.principal,
            phone: this.formValidate.phoneNumber,
          }
          // console.log(obj);
          ShopApi.addStoreInfo(obj)
            .then((res) => {
              console.log(res)
              if (res.status == 204) {
                this.$Message.success('保存成功')
              }
              setTimeout(() => {
                this.$router.go(-1)
              }, 200)
            })
            .catch((err) => {
              console.log(err)
              this.$Message.success('保存失败')
            })
        }
      }
    })
  }
}
